import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

function ExpiredSession() {
  const handleBackToLogin = () => {
    window.location.replace('/login');
  };

  return (
    <Container fluid className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <Row className="w-100 justify-content-center">
        <Col sm={8} md={6} lg={4}>
          <div className="text-center mb-5">
            <h4 className="text-primary mb-1 fw-bold">SIGO</h4>
            <p className="text-muted">Sistema de Gestão Odontológica</p>
          </div>
          <Card className="p-4 border-0">
            <Card.Body>
              <div className="text-center mb-3">
                <h5>Sessão Expirada</h5>
                <p className="text-muted mb-4">
                  Sua sessão terminou. Por favor, faça o login novamente para continuar.
                </p>
                <div className="d-grid">
                  <Button variant="primary" size="sm" onClick={handleBackToLogin}>
                    Voltar para o Login
                  </Button>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default ExpiredSession;
